<template>
  <div>
    <header>
      单位名称：
      <el-input
        v-model="searchKey"
        placeholder="请输入单位名称"
        style="width: 340px"
      ></el-input>
      状态：
      <el-select
        v-model="status"
        placeholder="请选择"
      >
        <el-option
          label="全部"
          value="-1"
        > </el-option>
        <el-option
          label="有效"
          value="1"
        > </el-option>
        <el-option
          label="无效"
          value="2"
        > </el-option>
      </el-select>
      <el-button
        type="primary"
        icon="el-icon-search"
        style="margin-left: 10px"
        @click="getList()"
      >查询</el-button>
      <el-button
        type="primary"
        @click="openAdd"
      >新增</el-button>
    </header>
    <el-table
      :data="tableData"
      border
      style="width: 100%; margin-top: 20px"
    >
      <el-table-column
        prop="companyName"
        label="单位名称"
        width="180"
      >
      </el-table-column>
      <el-table-column
        prop="platFormType"
        label="授权平台类型"
        width="180"
        align="center"
      >
      </el-table-column>
      <el-table-column
        label="授权模块"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="getModules(scope.row.id)"
          >配置模块</el-button>
        </template>
      </el-table-column>
      <el-table-column
        label="APP配置模块"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="getAPPModules(scope.row.id)"
          >配置模块</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="usedProjectCount"
        label="已使用项目数量"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="projectCount"
        label="授权项目数量"
        align="center"
      >
      </el-table-column>
      <el-table-column
        label="收款形式"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.receiveMoneyType }}
        </template>
      </el-table-column>

      <el-table-column
        label="状态"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.status == 1 ? "有效" : "无效" }}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="edit(scope.row)"
          >编辑</el-button>
          <el-button
            type="text"
            @click="del(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div
      class="tc"
      style="margin-top: 20px"
    >
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      >
      </el-pagination>
    </div>

    <el-dialog
      :title="editId ? '编辑' : '新增'"
      :visible.sync="addDialogVisible"
      width="1300px"
      center
      :close-on-click-modal="false"
      :before-close="handleClose"
      @close="dialogCloseFun"
    >
      <el-form
        ref="ruleForm"
        :model="form"
        label-width="160px"
        :rules="rules"
      >
        <el-form-item
          label="授权平台类型:"
          prop="platFormType"
        >
          <!-- <el-radio-group v-model="form.platFormType">
            <el-radio
              :label="item.id + ''"
              v-for="item in PlatList"
              :key="item.id"
              :value="item.id"
            >{{ item.platFormName }}
            </el-radio>
          </el-radio-group> -->
          <el-checkbox-group v-model="form.platFormType">
            <el-checkbox
              :label="item.id + ''"
              v-for="item in PlatList"
              :key="item.id"
            >{{ item.platFormName }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-row>
          <el-col :span="12">
            <el-form-item
              label="公司名称:"
              prop="companyName"
            >
              <el-input v-model="form.companyName"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              label="公司地址:"
              prop="address"
            >
              <el-cascader
                size="large"
                :options="options"
                v-model="form.selectedOptions"
              >
              </el-cascader>
              <el-input
                style="width: 222px; margin-left: 10px"
                v-model="form.address"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="公司简称:"
              prop="simpleName"
            >
              <el-input v-model="form.simpleName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="统一社会信用代码:"
              prop="unitCode"
            >
              <el-input v-model="form.unitCode"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              label="公司法人:"
              prop="companyLeader"
            >
              <el-input v-model="form.companyLeader"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              label="账号:"
              prop="userAccount"
            >
              <el-input v-model="form.userAccount"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="密码:"
              prop="userPwd"
            >
              <el-input
                v-model="form.userPwd"
                show-password
                placeholder="请输入8-16位包含字母数字的密码"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              label="最大授权项目数:"
              prop="projectCount"
            >
              <el-input
                v-model="form.projectCount"
                type="number"
                placeholder="最大数量100"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              label="代理商:"
              prop="companyAgent"
            >
              <el-input v-model="form.companyAgent"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              label="收款金额:"
              prop="receiveMoneyCount"
            >
              <el-input
                v-model="form.receiveMoneyCount"
                type="number"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              label="收款形式:"
              prop="receiveMoneyType"
            >
              <el-select
                v-model="form.receiveMoneyType"
                placeholder="请选择"
              >
                <el-option
                  :label="item.name"
                  :value="item.name"
                  v-for="item in getMoneyTypeList"
                  :key="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col
            :span="12"
            v-show="form.receiveMoneyType == '4'"
          >
            <el-form-item
              label="试用截至日期:"
              prop="endTime"
            >
              <el-date-picker
                v-model="form.endTime"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="账号备注:"
              prop="remark"
            >
              <el-input v-model="form.remark"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              label="有效状态:"
              prop="status"
            >
              <el-radio
                v-model="form.status"
                :label="1"
              >有效</el-radio>
              <el-radio
                v-model="form.status"
                :label="2"
              >无效</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="手机号码:"
              prop="telephone"
            >
              <el-input v-model="form.telephone"></el-input>
            </el-form-item>
          </el-col>

        </el-row>

        <el-form-item>
          <el-button
            type="primary"
            @click="submitForm('ruleForm')"
          >确定</el-button>
          <el-button @click="resetForm('ruleForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <funAuthorization
      ref="funAuthorization"
      @submitHandle="selectModules"
    ></funAuthorization>
  </div>
</template>

<script>
import { validatorPassword, validatorPhone } from "@/util/validateRules.js";
// TODO companyID没改，需要确认
import { regionData } from "element-china-area-data";
import funAuthorization from "@/components/funAuthorization.vue";
import authorization from "@/components/authorization.vue";

import { Api_SuperAdmin, Api_Base, Api_System } from "@/api/api";
import mixin_dialog from "@/mixins/dialog.js";

export default {
  components: {
    authorization,
    funAuthorization
  },
  mixins: [mixin_dialog],
  data() {
    return {
      options: regionData,
      totalCount: 0,
      currentPage: 1,
      pagesize: 10,
      selectedOptions: [],
      getMoneyTypeList: [],
      PlatList: [],
      searchKey: "",
      status: "-1",
      authorizationShow: false,
      tableData: [],
      addDialogVisible: false,
      originalPassword: '', // 新增：存储原始密码
      form: {
        platFormType: [],
        status: 1,
      },
      rules: {
        platFormType: [
          {
            required: true,
            message: "请选择平台类型",
            trigger: "blur",
          },
        ],
        companyName: [
          {
            required: true,
            message: "请输入公司名称",
            trigger: "blur",
          },
          //{ min: 1, max: 16, message: '长度不超过16个字符', trigger: 'blur' }
        ],
        simpleName: [
          {
            required: true,
            message: "请输入公司简称",
            trigger: "blur",
          },
          //{ min: 1, max: 10, message: '长度不超过10个字符', trigger: 'blur' }
        ],
        address: [
          {
            required: true,
            message: "请输入地址",
            trigger: "blur",
          },
        ],
        unitCode: [
          {
            required: true,
            message: "请输入统一社会信用代码",
            trigger: "blur",
          },
        ],
        companyLeader: [
          {
            required: true,
            message: "请输入公司法人",
            trigger: "blur",
          },
        ],
        projectCount: [
          {
            required: true,
            message: "请输入项目最大授权数",
            trigger: "blur",
          },
        ],
        companyAgent: [
          {
            required: true,
            message: "请输入代理商",
            trigger: "blur",
          },
        ],
        receiveMoneyCount: [
          {
            required: true,
            message: "请输入收款金额",
            trigger: "blur",
          },
        ],
        receiveMoneyType: [
          {
            required: true,
            message: "请选择收款方式",
            trigger: "blur",
          },
        ],
        remark: [
          {
            required: true,
            message: "请输入备注",
            trigger: "blur",
          },
        ],
        status: [
          {
            required: true,
            message: "请选择状态",
            trigger: "blur",
          },
        ],
        userAccount: [
          {
            required: true,
            message: "请输入用户账户",
            trigger: "blur",
          },
        ],
        userPwd: [
          {
            // 动态判断是否必填
            validator: (rule, value, callback) => {
              if (this.editId && value === this.originalPassword) {
                callback(); // 编辑时密码未变，跳过校验
              } else if (!value) {
                callback(new Error('请输入用户密码'));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
          {
            // 动态判断是否校验密码格式
            validator: (rule, value, callback) => {
              if (this.editId && value === this.originalPassword) {
                callback(); // 编辑时密码未变，跳过校验
              } else {
                validatorPassword(rule, value, callback);
              }
            },
            trigger: "blur",
          },
        ],
        telephone: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: "blur",
          },
          {
            trigger: "blur",
            validator: validatorPhone,
          },
        ],
      },
      companyId: "",
      propsKey: [],
      editId: 0,
      haveID: "",
      // 1为配置授权，2为APP配置授权
      type: 0,

    };
  },
  created() {
    this.getList();

    Api_Base.getMoneyTypeList().then((res) => {
      this.getMoneyTypeList = res.data.data;
    });

    Api_System.getPlatList().then((res) => {
      this.PlatList = res.data.data;
      // this.PlatList.map(item => {
      //   if (item.platFormName === '智慧建造云平台') {
      //     this.form.platFormType = item.id + ''
      //   }
      // })
      // form.platFormType
    });

    // 获取全部菜单
    // this.getAllMenu()
  },
  methods: {
    openAdd() {
      this.addDialogVisible = true;
      this.form = {
        platFormType: [],
      };
      // this.form = {
      //   platFormType: '',
      //   status: 1
      // }
      this.form.status = 1;
    },
    // getAllMenu() {
    //   //   // 超级管理员设置公司权限，列表展示全部
    //   Api_SuperAdmin.menuList().then(res => {
    //     const { data: { data, statusCode } } = res
    //     let tempArr = []
    //     if (statusCode == 200) {
    //       data.map(item => {
    //         tempArr.push(item.id)
    //         item.listTreeMenus.map(child => {
    //           tempArr.push(child.id)
    //         })
    //       })

    //       this.haveID = tempArr.join()
    //       console.log('--haveID---', this.haveID)
    //     }
    //   })
    // },
    // 获取公司所有菜单（不包含根菜单id）
    getModules(val) {

      this.companyId = val;
      this.type = 1;
      Api_SuperAdmin.modulesSubDetail(val).then((res) => {
        if (res.data.data && res.data.data.authorityMenuId) {
          this.propsKey = res.data.data.authorityMenuId.split(",");
        }
        this.$refs.funAuthorization.open(0, this.propsKey)

        // this.authorizationShow = true;
        // this.$refs.authorization.open();
      });
    },
    // 获取公司所有APP菜单（不包含根菜单id）
    getAPPModules(val) {
      this.companyId = val;
      this.type = 2;
      Api_SuperAdmin.modulesSubAPPDetail(val).then((res) => {
        if (res.data.data && res.data.data.authorityMenuId) {
          this.propsKey = res.data.data.authorityMenuId.split(",");
        }
        // this.authorizationShow = true;
        this.$refs.funAuthorization.open(0, this.propsKey)
        // this.$refs.authorization.open();
      });
    },
    selectModules(modules) {
      if (this.type === 1) {
        // 配置授权
        this.setModulesManage(modules);
      } else {
        // APP配置授权
        this.setAPPModules(modules);
      }
    },
    // 配置授权
    setModulesManage(modules) {
      Api_SuperAdmin.setModules({
        companyId: this.companyId,
        menuIds: modules.join(","),
      }).then((res) => {
        const {
          data: { statusCode, errors },
        } = res;
        if (statusCode === 200) {
          this.propsKey = ""
          this.$message({
            type: "success",
            message: "设置成功!",
          });
          this.type = 0;
        } else {
          this.$showMessage("失败", errors && errors[0].messages[0]);
        }
      });
    },
    // APP配置授权
    setAPPModules(modules) {
      Api_SuperAdmin.setAPPModules({
        companyId: this.companyId,
        menuIds: modules.join(","),
      }).then((res) => {
        const {
          data: { statusCode, errors },
        } = res;
        if (statusCode === 200) {
          this.$message({
            type: "success",
            message: "设置成功!",
          });
          this.authorizationShow = false;
          this.type = 0;
        } else {
          this.$showMessage("失败", errors && errors[0].messages[0]);
        }
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.form.projectCount < 101) {
            this.add();
          } else {
            this.$message({
              type: "warning",
              message: "最大授权项目数不能超过100",
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm() {
      this.addDialogVisible = false;
      this.form = {
        platFormType: [],
      };
      this.editId = 0;
    },
    edit(item) {
      this.editId = item.id;
      Api_SuperAdmin.detail(item.id).then((res) => {
        item = res.data.data;
        if (item.platFormType && item.platFormType.length != 0) {
          item.platFormType = item.platFormType.split(",");
        } else {
          item.platFormType = [];
        }
        item.selectedOptions = [
          item.provinceId + "",
          item.cityId + "",
          item.areaId + "",
        ];
        this.form = item;
        this.originalPassword = item.userPwd; // 新增：存储原始密码
        this.addDialogVisible = true;
      });
    },
    del(item) {
      this.$confirm("是否删除此公司?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        Api_SuperAdmin.del(item.id).then((res) => {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.getList();
        });
      });
    },
    add() {
      this.form.provinceId = this.form.selectedOptions[0];
      this.form.cityId = this.form.selectedOptions[1];
      this.form.areaId = this.form.selectedOptions[2];
      if (Array.isArray(this.form.platFormType)) {
        this.form.platFormType = this.form.platFormType.join(",");
      }
      if (this.form.id) {
        Api_SuperAdmin.edit(this.form).then((res) => {
          if (res.data.data) {
            this.$message({
              type: "success",
              message: "更新成功!",
            });
            this.addDialogVisible = false;
            this.form = {
              platFormType: [],
            };
            this.getList();
          } else {
            this.$message({
              type: "error",
              message: res.data.errors,
            });
          }
        });
      } else {
        Api_SuperAdmin.add(this.form).then((res) => {
          if (res.data.data) {
            this.$message({
              type: "success",
              message: "添加成功!",
            });
            this.addDialogVisible = false;
            this.form = {
              platFormType: [],
            };
            this.getList();
          } else {
            this.form.platFormType = [];
            this.$message({
              type: "error",
              message: res.data.errors,
            });
          }
        });
      }
    },
    getList() {
      Api_SuperAdmin.list({
        pageSize: this.pagesize,
        pageIndex: this.currentPage,
        companyName: this.searchKey,
        status: this.status,
      }).then((res) => {
        this.tableData = res.data.data.tList;
        this.totalCount = res.data.data.totalCount;
      });
    },
    handleClose() {
      this.addDialogVisible = false;
    },
    closeAuthor(val) {
      this.authorizationShow = val;
      this.propsKey = [];
      this.companyId = "";
    },
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
  },
};
</script>
